module.exports = __webpack_public_path__ + "static/media/win.74c6343b.wav";